//address type
export const pick_up = "1";
export const drop_off = "2";

//Customer Requests tab constants

export const active = "0";
export const completed = "1";
export const cancelled = "2";
